import React from 'react'
import ReactSelect from 'react-select'
import styles from './BoxShadowInput.module.css' // Assurez-vous de mettre à jour le chemin du fichier CSS

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    background: 'var(--white)',
    borderColor: 'var(--washed-gray)',
    minHeight: '28px',
    height: '28px',
    boxShadow: state.isFocused ? null : null,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '28px',
    padding: '0 6px',
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1
    const transition = 'opacity 300ms'

    return {
      ...provided,
      opacity,
      transition,
      color: 'var(--dark-gray)',
      fontFamily: 'var(--sans-serif)', // Changer la police du texte du singleValue
      fontSize: 'var(--size-font-input)', // Changer la taille du texte du singleValue
    }
  },
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? 'var(--darkened-background)'
      : 'var(--white)', // Changer la couleur d'arrière-plan de l'option
    color: state.isFocused ? 'var(--dark-gray)' : 'var(--dark-gray)', // Changer la couleur du texte de l'option
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: 'var(--white)', // Changer la couleur de fond du menu déroulant
  }),
  indicatorSeparator: (state) => ({
    display: 'none',
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '28px',
  }),
}

const BoxShadowInput = ({ name, value, onChange }) => {
  const boxShadowOptions = [
    { name: 'Aucun', value: 'none' },
    { name: 'Forma', value: '0 20px 27px 0 rgba(0,0,0,.05)' },
    { name: 'Commun', value: '0 1px 2px rgba(0, 0, 0, 0.15)' },
    { name: 'Linéaire', value: '0 10px 20px rgba(0, 0, 0, 0.15)' },
    { name: 'Static', value: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' },
    { name: 'Intense', value: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px' },
    {
      name: 'Survol',
      value:
        'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
    },

    {
      name: 'Stripe',
      value:
        'rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px',
    },
    {
      name: 'Facebook',
      value:
        'rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset',
    },
    {
      name: 'Mac 1',
      value: 'rgba(0, 0, 0, 0.56) 0px 22px 70px 4px',
    },
    {
      name: 'Mac 2',
      value: 'rgba(0, 0, 0, 0.2) 0px 20px 30px',
    },
    {
      name: 'Trello',
      value:
        'rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px',
    },
    // Ajoutez plus d'options d'ombre ici si nécessaire
  ]

  const options = boxShadowOptions.map((option) => ({
    value: option.value,
    label: option.name,
  }))

  const handleChange = (selectedOption) => {
    onChange({
      target: {
        name: name,
        value: selectedOption ? selectedOption.value : '',
      },
    })
  }

  const selectedOption = options.find((option) => option.value === value)

  return (
    <div className={styles.container}>
      <ReactSelect
        value={selectedOption}
        onChange={handleChange}
        options={options}
        className={styles.select}
        styles={customStyles}
      />
    </div>
  )
}

export default BoxShadowInput
